export default __webpack_public_path__ + "static/media/icon-ic-dropoff.3eb4c5d6.svg";